export default [   
  {
    path: '/punjabi-letter/list',
    name: 'punjabi-letter',
    component: () => import('@/views/punjabi-letter/index.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Letters List',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Punjabi Letters', active: true }
      ]
    }
  },
  {
    path: '/punjabi-letter/add',
    name: 'punjabi-letter-add',
    component: () => import('@/views/punjabi-letter/action.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Letters List',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Punjabi Letters', active: true }
      ]
    }
  },
  {
    path: '/punjabi-letter/:id/edit',
    name: 'punjabi-letter-edit',
    component: () => import('@/views/punjabi-letter/action.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Letters List',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Update Punjabi Letter', active: true }
      ]
    }
  }
]
